import { WithStringValues } from "common/utils/types";

import { ReviewsSearch } from "../types";

export const urls = {
  clinicReviews: () => "/api/client/v1/reviews/clinic-reviews/",
  clientReviews: () => "/api/client/v1/reviews/client-reviews/",
  createClientReview: () => "/api/client/v1/reviews/",
};

export const keys = {
  all: () => ["reviews-all"],

  clinicReviews: () => [...keys.all(), "clinic-reviews"],
  clinicReviewLists: () => [...keys.clinicReviews(), "list"],
  clinicReviewList: (search: WithStringValues<ReviewsSearch>) => [
    ...keys.clinicReviewLists(),
    search,
  ],

  clientReviews: () => [...keys.all(), "client-reviews"],
  clientReviewLists: () => [...keys.clientReviews(), "list"],
  clientReviewList: (search: WithStringValues<ReviewsSearch>) => [
    ...keys.clientReviewLists(),
    search,
  ],
};
